import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	noMessageBlastTitle: {
		color: colors.gray[700],
		fontSize: "32px",
		lineHeight: "48px"
	},
	noMessageBlastText: {
		color: colors.gray[500],
		fontSize: "20px"
	},
	noMessageBlastImage: {
		maxWidth: "100%"
	},
	messageBlastStatusName: {
		fontSize: "24px"
	},
	coloredTitle: {
		color: colors.getPrimaryColor()
	}
})

export default useStyles
